const getNumber = (value: string) => value.replace(/,/g, "");

export { getNumber };
